  import {LuSearch} from "@/Components/Icons/Icons";
  export default {
    row1:[
    {
      column: "column1",
      columnWidth: "45%",
      rows: {
       row1: [
          {
            name: "importRequirementDocumentName",
            label: "Document Name",
            component: "text-field",
            width: "100%",
          }
        ],
       
        
       
      },
    },
    {
      column: "colum2",
      columnWidth: "45%",
      rows: {
        row1: [
          {
            name: "importRequirementDate", 
            label: "Date",
            component: "dateselector",
            width: "100%",
          },
        ],
         
        
      },
    },
  ]
  };
  
